import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleCard from '../CollapsibleCard';
import { DropTable } from '../dashboard/components';
import { nullStateMessages } from '../../src/ReportsTabs/components/QuantQualInsights/nullStateMessages'
import { externalFrameworkMetadata } from '../../src/actions/reports';
import style from './style.module.css';

const defaultTitle = 'Performance According to Alternative Framework';
const { externalFrameworkHasNoData: getNullStateMessage } = nullStateMessages;

function mapLevels(parentsMapping = []) {
  return parentsMapping.reduce((acc, p) => ((p === -1)
    ? [...acc, 0]
    : [...acc, acc[p] + 1]), []);
}

function mapChildren(p) {
  // eslint-disable-next-line no-unused-vars
  const result = p.map(c => []);

  p.forEach((parent, pidx) => {
    if (result[parent]) {
      result[parent].push(pidx);
    }
  });

  return result;
}

function mapDescendants(directDescendants = []) {
  const result = [];
  // flipping is required so higher indices may be reference first
  const flipped = directDescendants.reverse();
  flipped.forEach((f, fidx) => {
    const actualIdx = (flipped.length - fidx - 1);
    if (f.length) {
      result[actualIdx] = f;
      f.forEach((subF) => {
        result[actualIdx] = [
          ...result[actualIdx],
          ...result[subF],
        ];
      });
    } else {
      result[actualIdx] = [];
    }
  });
  return result;
}

const recurseBranch = (branch) => {
  if (!branch) return [];
  if (_.isEmpty(branch.children)) return [branch];
  const kids = _.map(branch.children, c => ({ parent: branch, ...c }));
  return [branch].concat(_.flattenDeep(_.map(kids, recurseBranch)));
};

export default function ExternalFrameworkCard({ title = defaultTitle, rows = [], reportType }) {
  const dataWithParents = _.flatten(_.map(rows, recurseBranch));
  const data = _.map(dataWithParents, d => [d.name, d.averageStarted, `${d.completedQuestions}%`, `${d.correctOnFirstTry}%`]);
  const parents = _.map(dataWithParents, d => _.findIndex(dataWithParents, { id: _.get(d.parent, 'id') }));

  const transformedRows = [
    {
      descendants: mapDescendants(mapChildren(parents)),
      levels: mapLevels(parents),
      parents,
    },
    ...data,
  ];

  const titleToShow = _.isEmpty(dataWithParents) ? title : `Performance by ${dataWithParents[0].frameworkName}`;
  const { isPublished, hasResponses } = externalFrameworkMetadata(data);

  return (
    isPublished && (
      <CollapsibleCard
        title={titleToShow}
        reportType={reportType}
      >
        <div style={{ padding: 20 }}>
          {hasResponses && (
            <DropTable rows={transformedRows}>
              <tr className={style.dropTableHeaderRow}>
                <th>
                  <span>Primary learning objective</span>
                </th>
                <th>
                  <span>Average</span>
                  <span>started</span>
                </th>
                <th>
                  <span>Questions</span>
                  <span>Completed</span>
                </th>
                <th>
                  <span>Questions correct</span>
                  <span>on first try</span>
                </th>
              </tr>
            </DropTable>
          )}
          {!hasResponses && (
            <div className={style.emptyState}>
              {getNullStateMessage()}
            </div>
          )}
        </div>
      </CollapsibleCard>
    )
  );
}

ExternalFrameworkCard.propTypes = {
  reportType: PropTypes.string,
  title: PropTypes.string,
  rows: PropTypes.array,
};
